import {registerComponent} from '../../shared/react/registrar';
import {ItemDetailPage} from '../../shared/items/item-detail/ItemDetailPage';

registerComponent(ItemDetailPage, 'ItemDetailPage');
